<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-select
        :items="items"
        return-object
        item-text="nazev"
        v-model="selectedItem"
        :label="label"
        :hide-details="hideDetails"
        :outline="outline"
        class="mt-0"
        :rules="rules"
        :disabled="disabled"
        :class="{ 'mx-2': !noMx }"
      >
      </v-select>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  data: function () {
    return {
      items: [],
      selectedItem: null
    }
  },
  props: {
    label: String,
    produkt: Number,
    hideDetails: Boolean,
    outline: Boolean,
    rules: Array,
    value: Array,
    all: Boolean,
    disabled: Boolean,
    noMx: Boolean,
    nahradniprodukty: Array
  },
  watch: {
    selectedItem (v) {
      this.$emit("changed", v);
      this.$emit("input", v.id);
    }
  },
  mounted: function() {
    this.load();
  },
  methods: {
    load: function(v) {
      if (typeof this.nahradniprodukty !== "undefined" && this.nahradniprodukty != null) {
        this.items = this.nahradniprodukty;
        if (this.value != null) {
          var nahradni_produkt = this.value;
          var $f = this.items.filter((x) => { return x.id == nahradni_produkt; });
          if ($f.length > 0)
            this.selectedItem = $f[0];
          else
            this.selectedItem = null;
        }
        else {
          this.selectedItem = null;
        }
      }
      else {
        window.api.get("produkty/" + this.produkt + "/nahradni").then(function(_body) {
          this.items = _body;
          if (this.value != null) {
            var $value = this.value;
            var $f = this.items.filter((x) => { return x.id == $value; });
            if ($f.length > 0)
              this.selectedItem = $f;
            else
              this.selectedItem = null;
          }
          else {
            this.selectedItem = null;
          }
        }.bind(this)).catch(function(err) {
          console.log(err);
        }.bind(this));
      }
    }
  },
  components: {

  }
}
</script>
<style scoped>
.v-select__selection-text {
  max-width: 100px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/NahradniProduktySelect.vue